export var SettingsGroup = /*#__PURE__*/ function(SettingsGroup) {
    SettingsGroup["TaskStatusAutomation"] = "TaskStatusAutomation";
    SettingsGroup["PhaseAutomation"] = "PhaseAutomation";
    SettingsGroup["ScheduledNotifications"] = "ScheduledNotifications";
    SettingsGroup["NewDependenciesAndLag"] = "NewDependenciesAndLag";
    return SettingsGroup;
}({});
export var SettingType = /*#__PURE__*/ function(SettingType) {
    SettingType["MarkTaskAsCompletedIfSubTaskIs"] = "MARK_PARENT_TASK_TO_COMPLETED_IF_SUBTASK_IS_COMPLETED";
    SettingType["MarkTaskAsInProgressIfSubTaskIs"] = "MARK_PARENT_TASK_TO_IN_PROGRESS_IF_SUBTASK_CHANGES";
    SettingType["MarkSubTasksAsCompletedIfTaskIs"] = "MARK_SUBTASKS_COMPLETED_IF_PARENT_IS_COMPLETED";
    SettingType["AlignPhaseDates"] = "BOUND_PHASE_DATES_TO_TASKS_START_AND_DUE_DATE_BOUNDARIES";
    SettingType["ManualPhaseSequencing"] = "ENABLE_MANUAL_PHASE_SEQUENCING";
    SettingType["StopScheduledNotifications"] = "STOP_SCHEDULE_NOTIFICATION_PROJECT_STATUSES";
    SettingType["OtpAuthentication"] = "CUSTOMER_AUTHENTICATION_OTP_ENABLED";
    SettingType["RevenueRecognitionAtProjectLevel"] = "ALLOW_USERS_TO_SET_REV_REC_CONFIG_AT_PROJECT_LEVEL";
    SettingType["TMRevenueRecognitionAtProjectLevel"] = "ALLOW_USERS_TO_SET_TM_REV_REC_CONFIG_AT_PROJECT_LEVEL";
    SettingType["EnableNewDependenciesAndLag"] = "ENABLE_NEW_DEPENDENCIES_AND_LAG";
    SettingType["CustomCalendarConfiguration"] = "CUSTOM_CALENDAR_CONFIGURATION";
    return SettingType;
}({});
export const SettingsByGroup = {
    ["TaskStatusAutomation"]: [
        "MARK_SUBTASKS_COMPLETED_IF_PARENT_IS_COMPLETED",
        "MARK_PARENT_TASK_TO_COMPLETED_IF_SUBTASK_IS_COMPLETED",
        "MARK_PARENT_TASK_TO_IN_PROGRESS_IF_SUBTASK_CHANGES"
    ],
    ["PhaseAutomation"]: [
        "BOUND_PHASE_DATES_TO_TASKS_START_AND_DUE_DATE_BOUNDARIES",
        "ENABLE_MANUAL_PHASE_SEQUENCING"
    ],
    ["NewDependenciesAndLag"]: [
        "ENABLE_NEW_DEPENDENCIES_AND_LAG"
    ],
    ["ScheduledNotifications"]: [
        "STOP_SCHEDULE_NOTIFICATION_PROJECT_STATUSES"
    ]
};
